import useSWR from 'swr'
import { getProductsWithIDs } from '@lib/api/shopify'

export default function useProductsWithIds(ids = []) {
  const { data, error } = useSWR(`/products-with-ids?ids=${ids.join('|')}`, () => getProductsWithIDs(ids))
  return {
    products: data?.nodes || undefined,
    isLoading: !error && !data,
    isError: error
  }
}
